import axios from 'axios'
import { BUSCAR_CAIXA_ABERTO } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default function buscarCaixaAberto (codigoEmpresa) {
  const url = `${URL}/fechamento-caixa-usuario/empresa/${codigoEmpresa}/usuario/caixa-aberto`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG)
    .then(response => dispatch({
      type: BUSCAR_CAIXA_ABERTO,
      payload: response
    }))
}
